import { getData } from '../plugins/ApiCalls'

export function fetchFormConnections() {
  return getData('formconnections')
}
export function fetchFormConnection(data) {
  return getData('formconnections/' + data.formId)
}
